<template>
  <div class="container-detail">
    <aside class="aside-resume">
      <aside-menu />
    </aside>
    <div class="scrollY">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    // Loading: () => import('@/components/ui/Loading.vue')
    AsideMenu: () => import('@/components/Profile/AsideMenu')
  },
  data () {
    return {
      loading: true,
      menu: []

    }
  },
  methods: {
    ...mapActions(['getMenu']),
    getLinkLocal ({ section, path }) {
      if (section === 'external') {
        return path
      }
      const baseURL = `${process.env.VUE_APP_PROTOCOL}://${window.location.hostname}`
      const linkPath = path ? `${process.env[`VUE_APP_${section.toUpperCase()}`]}/${path}`.replace('//', '/') : ''
      return `${baseURL}${linkPath}`
    }
  },
  computed: {
    applicationMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Solicitudes')
        return menuSelected
      }
      return null
    },
    customerMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Clientes')
        return menuSelected
      }
      return null
    },
    contractMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Créditos')
        return menuSelected
      }
      return null
    },
    buzonPldMenu () {
      if (this.menu) {
        const menuSelected = this.menu.reduce((accum, category) => {
          const itemList = category.subcategories.reduce((accumItem, el) => (accumItem = [...accumItem, ...el.items]), [])
          return [...accum, ...itemList]
        }, []).find(item => item.name === 'Buzón PLD')
        return menuSelected
      }
      return null
    }
  },
  created () {
    this.getMenu()
      .then(resp => {
        this.menu = resp.categories
        this.loading = false
      })
  }

}
</script>
